import React from 'react';
import styles from './TrackSelector.module.scss';

const TrackSelectorButton = ({
  children,
  style = {},
  onClick,
  className,
  id,
  disabled,
}) => (
  <button
    type="button"
    onClick={onClick}
    className={`${styles.trackSelectorButton} ${className || ''}`}
    id={id}
    disabled={disabled}
    style={style}
  >
    {children}
  </button>
);

export default TrackSelectorButton;
